import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "components/basic/typography";
import { Vendor } from "pages/userAuthentication/signUp";
import InsuranceSection from "pages/dashboard/pages/profile/formPages/documentsProfileDashboard/components/InsuranceSection";
import InstallationSection from "pages/dashboard/pages/profile/formPages/documentsProfileDashboard/components/InstallationSection";

interface DocumentsStepProps {
  vendor: Vendor;
  onSave: (updates: Record<string, string | null>) => Promise<boolean>;
}

/** The expiry dates vendors who joined before they were collected still owe. */
const DocumentsStep: React.FC<DocumentsStepProps> = ({ vendor, onSave }) => {
  const { t } = useTranslation("onboarding");

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="body1">{t("documents.intro")}</Typography>
      <InsuranceSection vendor={vendor} onSave={onSave} />
      <InstallationSection vendor={vendor} onSave={onSave} />
    </Box>
  );
};

export default DocumentsStep;
